import React from 'react';
import {
  Box,
  Container,
  Typography,
  Paper,
  Grid,
} from '@mui/material';
import { NotificationTest } from '../../../components/NotificationTest';
import { NotificationPreferences } from './NotificationPreferences';

const AdminNotifications = () => {
  return (
    <Container maxWidth="lg">
      <Box sx={{ mt: 4, mb: 4 }}>
        <Typography variant="h4" gutterBottom>
          Notification Management
        </Typography>
        
        <Grid container spacing={3}>
          {/* Test Notifications Panel */}
          <Grid item xs={12} md={6}>
            <Paper sx={{ p: 3, height: '100%' }}>
              <Typography variant="h6" gutterBottom>
                Test Notifications
              </Typography>
              <Typography variant="body2" color="text.secondary" paragraph>
                Enable notifications and send test messages to verify the system is working.
              </Typography>
              <NotificationTest />
            </Paper>
          </Grid>

          {/* Notification Settings Panel */}
          <Grid item xs={12} md={6}>
            <Paper sx={{ p: 3, height: '100%' }}>
              <Typography variant="h6" gutterBottom>
                Default Notification Settings
              </Typography>
              <Typography variant="body2" color="text.secondary" paragraph>
                Configure default notification preferences for all users.
              </Typography>
              <NotificationPreferences />
            </Paper>
          </Grid>

          {/* Notification History Panel */}
          <Grid item xs={12}>
            <Paper sx={{ p: 3 }}>
              <Typography variant="h6" gutterBottom>
                Notification History
              </Typography>
              <Typography variant="body2" color="text.secondary" paragraph>
                View all notifications sent through the system.
              </Typography>
              {/* TODO: Add notification history table */}
              <Typography color="text.secondary">
                Coming soon: Detailed notification history and analytics
              </Typography>
            </Paper>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export default AdminNotifications;
